module.exports = __webpack_public_path__ + "img/Weapon_54.879d8663.png";